module.exports = __webpack_public_path__ + "img/schweizerischesZivilgesetzbuch.68371427.svg";